import { SiteMetaData, SocialPlatform } from '../../types/site';

/**
 * Transform raw data into SiteMetaData
 * @param data {any}
 * @returns
 */
export const transformSiteMetaData = (data: any): SiteMetaData => {
  return {
    title: data.title,
    brandName: data.brandName,
    buildVersion: data.buildVersion,
    logo: data.logo,
    searchServiceUrl: data.searchServiceUrl,
    siteUrl: data.siteUrl,
    socialPlatforms: data.socialPlatforms as { [key in SocialPlatform]: string }
  };
};

export const transformSite = (data: any) => {
  const site: any = structuredClone(data, {});
  if (site.siteMetadata) site.siteMetadata = transformSiteMetaData(site.siteMetadata);
  return site;
};
